import { useContext } from 'react';
import { Alert } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import { AppContext } from '../context';

export default function Toast() {
    const { toast } = useContext(AppContext);
    
    return (
        <AnimatePresence>
            {toast && (
                <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0,  scale: 1    }}
                    exit={{   opacity: 0, y: 20,  scale: 0.95 }}
                    transition={{ duration: 0.25 }}
                    style={{
                        position: 'fixed', bottom: 24,
                        left: 16, right: 16, zIndex: 9999,
                        display: 'flex', justifyContent: 'center',
                        pointerEvents: 'none',
                    }}
                >
                    <Alert
                        color={toast?.color || 'success'}
                        variant="solid"
                        sx={{
                            borderRadius: 'var(--joy-radius-lg)',
                            px: 2.5, py: 1.5,
                            fontSize: 13, fontWeight: 600,
                            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                            maxWidth: 'min(560px, calc(100vw - 32px))',
                            lineHeight: 1.4,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            pointerEvents: 'auto',
                        }}
                    >
                        {toast?.msg}
                    </Alert>
                </motion.div>
            )}
        </AnimatePresence>
    );
}